/**
 * 辅助方法：根据 .cell 计算相关筛选项下拉菜单的位置
 * @param {HTMLElement} filterElm 
 * @param {HTMLElement} arrowElm 
 * @param {HTMLElement} cellElm 
 * @returns {object}
 */
function _calcFilterPosition(filterElm, arrowElm, cellElm) {
  let leftVlu = arrowElm.getBoundingClientRect().right
    - filterElm.offsetWidth;
  let topVlu = cellElm.getBoundingClientRect().top
    + cellElm.offsetHeight;
  // 按组件原有逻辑，菜单下方显示不全时，顶住底边
  const bottomDiff = topVlu + filterElm.offsetHeight - window.innerHeight;
  if (bottomDiff > 0) {
    topVlu -= bottomDiff;
  }
  leftVlu = parseInt(leftVlu, 10);
  topVlu = parseInt(topVlu, 10);
  const originDisplay = filterElm.style.display;
  filterElm.style.display = 'none';
  filterElm.style.left = `${leftVlu}px`;
  filterElm.style.top = `${topVlu}px`;
  filterElm.style.display = originDisplay;
  console.log('[ExJcTable] fix filter position: ', leftVlu, topVlu);
  return {
    left: leftVlu,
    top: topVlu
  };
}

/**
 * 辅助方法：关闭页面上所有筛选项下拉菜单
 */
function _closeAllFilterDropdowns() {
  // console.log(111)
  Array.prototype.forEach.call(
    document.querySelectorAll('.jc-table-filter'),
    (ele) => {
      ele.style.display = 'none';
      if (ele.dataset.col) {
        let thElm = document.querySelector(`.${ele.dataset.col}`);
        if (!thElm) {
          // window.removeEventListener('resize', _closeAllFilterDropdowns);
          return;
        }
        let arrowElm = thElm.querySelector('.jc-icon-arrow-up');
        if (arrowElm) {
          arrowElm.click();
          window.removeEventListener('resize', _closeAllFilterDropdowns);
          console.log('close filter');
        }
        thElm = null;
        arrowElm = null;
      }
    }
  );
}

/**
 * 在 http://git.jd.com/daasfe/element/issues/73 得到解决之前，在项目中临时修复
 * @param {object} Vue 
 * @param {object} JElementUI 
 */
// eslint-disable-next-line import/prefer-default-export
export const fixFilterDropdown = (Vue, JElementUI) => { 
  const ExJcTable = {
    name: 'ExJcTable',
    mixins: [JElementUI.Table],
    mounted: function() { // eslint-disable-line
      this.__ffdMouseUpHandler = this.onTableMouseUp.bind(this);
      this.$el.addEventListener('mouseup', this.__ffdMouseUpHandler);
    },
    beforeDestroy: function() { // eslint-disable-line
      window.removeEventListener('resize', _closeAllFilterDropdowns);
      this.$el.removeEventListener('mouseup', this.__ffdMouseUpHandler);
      this.__ffdMouseUpHandler = null;
      clearInterval(this._fhcInterval);
      clearTimeout(this._fhcTimeout);
    },
    methods: {
      onTableMouseUp: function(e) { // eslint-disable-line
        let { target } = e;
        const isFilterArrow = target.classList.contains('jc-icon-arrow-down');
        const isFilterCell = target.classList.contains('cell')
          && !!target.querySelector('.jc-table__column-filter-trigger');
        if (isFilterArrow || isFilterCell) {
          let cellElm = isFilterCell
            ? target
            : target.parentNode.parentNode;
          this.onFilterHeaderClick(cellElm);
          cellElm = null;
        }
        target = null;
      },
      onFilterHeaderClick: function (cellElm) { // eslint-disable-line
        // console.log(cellElm)

        // 手动触发后
        clearTimeout(this._fhcTimeout);
        const colName = cellElm.parentNode.className.match(/\b(jc-table_\d+_column_\d+)\b/)[1];
        const fn = function(cellElm) {  // eslint-disable-line
          const arrowElm = cellElm.querySelector('.jc-icon-arrow-up');
          if (!arrowElm) {
            return;
          }
          // 可能存在多个下拉，要过滤出可见的那个
          const filterDropdownElms = Array.prototype.filter.call(
            document.querySelectorAll('.jc-table-filter'),
            ele => ele.style.display !== 'none'
          );
          if (!filterDropdownElms.length) {
            return;
          }
          const visibleFilter = filterDropdownElms[0];
          visibleFilter.dataset.col = colName;
          console.log('calc in timeout');
          _calcFilterPosition(visibleFilter, arrowElm, cellElm);

          this.checkFilterPosition(colName);
        }.bind(this, cellElm);
        this._fhcTimeout = setTimeout(fn, 100);

        cellElm = null;
      },
      checkFilterPosition: function(colName) { // eslint-disable-line
        // 保持打开状态期间
        clearInterval(this._fhcInterval);
        window.removeEventListener('resize', _closeAllFilterDropdowns);
        this._fhcInterval = setInterval(() => {
          const filterElms = Array.prototype.filter.call(
            document.querySelectorAll('.jc-table-filter'),
            ele => ele.style.display !== 'none'
          );
          let filterElm = filterElms[0]; // document.querySelector(`[data-col="${colName}"]`);
          let thElm = document.querySelector(`.${colName}`);
          if (!thElm || !filterElm/* || filterElm.style.display === 'none' */) {
            clearInterval(this._fhcInterval);
            window.removeEventListener('resize', _closeAllFilterDropdowns);
            // console.log(111, thElm, filterElm)
            return;
          }
          let arrowElm = thElm.querySelector('.jc-icon-arrow-up');
          if (!arrowElm) {
            return;
          }
          _calcFilterPosition(
            filterElm, 
            arrowElm, 
            thElm.firstElementChild
          );
          filterElm = null;
          thElm = null;
          arrowElm = null;
        }, 100);
        window.addEventListener('resize', _closeAllFilterDropdowns);
      }
    } // end of methods
  }; // end of ExJcTable

  // 替换默认组件
  JElementUI.Table = ExJcTable;
  Vue.component('JcTable', ExJcTable);
};



// WEBPACK FOOTER //
// ./src/components/common/JElementUIUtils.js